export const SET_FILTERS = 'SET_FILTERS';
export const SET_FILTERS_FETCHED = 'SET_FILTERS_FETCHED';
export const SET_COMPANY_FILTERS = 'SET_COMPANY_FILTERS';
export const SET_SAVED_FILTERS_LOADING = 'SET_SAVED_FILTERS_LOADING';
export const SET_COMPANY_DATA_REFRESH_TIME = 'SET_COMPANY_DATA_REFRESH_TIME';
